import React, { useEffect, useRef, useState } from "react";
import DashboardLayout from "../../layout/DashboardLayout";
import { useLocation, useNavigate } from "react-router-dom";
import ROUTE_PATH from "../../constant/route";
import BackArrow from "../../assets/svg/back-arrow.svg";
import { Box } from "@mui/material";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import CoversureLogo from "../../assets/svg/coversure-logo.svg";
import CalendarImg from "../../assets/svg/calendar.svg";
import UserImg from "../../assets/svg/user.svg";
import AccordionSection from "./accordionSection";
import ChooseBenefits from "./chooseBenefits";
import { useSelector } from "react-redux";
import { format } from "date-fns";
const WellnessServices = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const userData = useSelector((state: any) => state?.authentication?.userData);
  console.log("userData", userData);
  const containerRef = useRef<HTMLDivElement>(null);
  const [isStart, setIsStart] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const [policyList, setPolicyList] = useState<any>([]);
  const [selectData, setSelectData] = useState<any>({});
  useEffect(() => {
    if (userData.length > 0) {
      const data = userData?.map((item: any, index: any) => ({
        ...item,
        id: index,
      }))
      setPolicyList(data);
      setSelectData(data[0])
    }
  }, [userData]);
  
  const checkScrollPosition = () => {
    if (containerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = containerRef.current;
      setIsStart(scrollLeft === 10 || scrollLeft === 0);
      setIsEnd(scrollLeft + clientWidth >= scrollWidth);
    }
  };

  const scroll = (direction: "left" | "right") => {
    if (containerRef.current) {
      const scrollAmount = 300; // Adjust scroll amount as needed
      containerRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };
  useEffect(() => {
    const container = containerRef.current;

    if (!container) return;

    // Use ResizeObserver to monitor changes
    const resizeObserver = new ResizeObserver(() => {
      checkScrollPosition();
    });

    // Observe container element
    resizeObserver.observe(container);

    // Add scroll event listener
    container.addEventListener("scroll", checkScrollPosition);

    // Clean up
    return () => {
      resizeObserver.disconnect();
      container.removeEventListener("scroll", checkScrollPosition);
    };
  }, []);

  return (
    <DashboardLayout>
      <div className="p-[16px] lg:p-[38px] xl:p-[50px]">
        {/* <div className="sm:hidden flex items-center justify-between w-[100%]">
          <div
            className="w-[32%] h-[60px] rounded-[10px] cursor-pointer text-[9px] leading-[12px] text-white p-[12px] font-bold flex items-center justify-center text-center"
            style={
              location.pathname === ROUTE_PATH.HOSPICASH
                ? { backgroundColor: "#1E56FF", color: "white" }
                : { backgroundColor: "#E6ECFF", color: "#1E56FF" }
            }
            onClick={() => {
              navigate(ROUTE_PATH.HOSPICASH);
            }}
          >
            Hospicash Insurance
          </div>
          <div
            className="w-[48%] h-[60px] rounded-[10px] cursor-pointer text-[9px] leading-[12px] text-white p-[12px] font-bold flex items-center justify-center text-center"
            style={
              location.pathname === ROUTE_PATH.WELLNESS
                ? { backgroundColor: "#1E56FF", color: "white" }
                : { backgroundColor: "#E6ECFF", color: "#1E56FF" }
            }
            onClick={() => {
              navigate(ROUTE_PATH.WELLNESS);
            }}
          >
            Wellness Benefits
          </div>
          <div
            className="w-[48%] h-[60px] rounded-[10px] cursor-pointer text-[9px] leading-[12px] text-white p-[12px] font-bold flex items-center justify-center text-center"
            style={
              location.pathname === ROUTE_PATH.COMPREHENSIVE
                ? { backgroundColor: "#1E56FF", color: "white" }
                : { backgroundColor: "#E6ECFF", color: "#1E56FF" }
            }
            onClick={() => {
              navigate(ROUTE_PATH.COMPREHENSIVE);
            }}
          >
            Coversure Platform
          </div>
        </div> */}
        <div className="sm:hidden flex items-center w-[100%] text-[16px] leading-[20px] font-semibold mt-[16px] mb-[24px]">
          <img
            src={BackArrow}
            alt="BackArrow"
            className="block lg:hidden relative left-[-5%]"
            onClick={() => navigate(ROUTE_PATH.DASHBOARD)}
          />
          <span className="relative top-[-5px] left-[-5%]">
            Wellness Benefits
          </span>
        </div>
        <div>
          <div className="hidden sm:flex items-center justify-between mb-[21px]">
            <div className="text-[20px] leading-[26px] font-bold text-text-color-1 ">
              Current Benefits
            </div>
            {policyList?.length > 1 && (
              <Box
                className="hidden sm:flex items-center"
                sx={{ justifyContent: "center" }}
              >
                <div
                  onClick={() => !isStart && scroll("left")}
                  style={
                    isStart
                      ? {
                          border: "1px solid #D0D5DD",
                          borderRadius: "50%",
                          padding: "6px",
                          cursor: "pointer",
                        }
                      : {
                          border: "1px solid #1E56FF",
                          borderRadius: "50%",
                          padding: "6px",
                          cursor: "pointer",
                        }
                  }
                >
                  <KeyboardArrowLeftIcon
                    style={
                      isStart
                        ? { color: "#D0D5DD", fontSize: "30px" }
                        : { color: "#1E56FF", fontSize: "30px" }
                    }
                  />
                </div>
                <div
                  onClick={() => !isEnd && scroll("right")}
                  style={
                    isEnd
                      ? {
                          marginLeft: 18,
                          border: "1px solid #D0D5DD",
                          borderRadius: "50%",
                          padding: "6px",
                          cursor: "pointer",
                        }
                      : {
                          marginLeft: 18,
                          border: "1px solid #1E56FF",
                          borderRadius: "50%",
                          padding: "6px",
                          cursor: "pointer",
                        }
                  }
                >
                  <KeyboardArrowRightIcon
                    style={
                      isEnd
                        ? { color: "#D0D5DD", fontSize: "30px" }
                        : { color: "#1E56FF", fontSize: "30px" }
                    }
                  />
                </div>
              </Box>
            )}
          </div>
          <Box
            ref={containerRef}
            sx={{
              display: "flex",
              overflowX: "auto",
              gap: 3,
              scrollSnapType: "x mandatory",
              "&::-webkit-scrollbar": { display: "none" },
            }}
          >
            {policyList.map((item: any, index: number) => {
              return (
                <Box
                  sx={{ flex: "0 0 auto", scrollSnapAlign: "start" }}
                  key={index}
                  onClick={() => setSelectData(item)}
                >
                  <div
                    style={
                      selectData?.id === index
                        ? {
                            border: "1px solid blue",
                          }
                        : {}
                    }
                    className="bg-bg-color-11 lg:bg-white p-[16px] xl:py-[30px] xl:px-[16px] rounded-[25px] w-[296px] lg:w-[350px] xl:w-[400px] border-[1px] border-bg-color-10 lg:border-0"
                  >
                    <img
                      src={CoversureLogo}
                      alt="CoversureLogo"
                      className="lg:w-[400px] h-[18px] lg:h-[30px] p-0 m-[auto]"
                    />
                    <div className="text-[12px] leading-[18px] lg:text-[15px] lg:leading-[22px] font-semibold text-text-color-3 mt-[20px] mb-[10px]">
                      Member name
                    </div>
                    <div className="flex items-center text-[14px] leading-[18px] lg:text-[16px] lg:leading-[22px] font-semibold lg:mb-[21px] mb-[21px]">
                      <img
                        src={UserImg}
                        alt="UserImg"
                        className="w-[20px] lg:w-[28px]"
                        style={{ marginRight: "6px" }}
                      />
                      {item?.firstName + " " + item?.lastName}
                    </div>
                    <div className="text-[12px] leading-[18px] lg:text-[15px] lg:leading-[22px] text-text-color-1 flex items-center ">
                      <img
                        src={CalendarImg}
                        alt="CalendarImg"
                        style={{ marginRight: "6px" }}
                      />
                      {item?.policyStartDate && item?.policyEndDate
                        ? `Valid from ${format(
                            new Date(item?.policyStartDate),
                            "dd MMMM yyyy"
                          )} to ${format(
                            new Date(item?.policyEndDate),
                            "dd MMMM yyyy"
                          )}`
                        : "-"}
                    </div>
                  </div>
                </Box>
              );
            })}
          </Box>
        </div>
        <ChooseBenefits selectData={selectData} />
        <AccordionSection />
      </div>
    </DashboardLayout>
  );
};

export default WellnessServices;
